export default {
  countryError: {
    en: 'Unsupported shipping country. Only US and Canada are supported.',
  },
  addressError: {
    en: 'Unsupported shipping address',
  },
  unexpectedError: {
    en: 'An unexpected error occurred. Please try again.',
  },
  userError: {
    en: 'Only letters and spaces are allowed',
  },
  postalCodeError: {
    en: 'Postal code is empty',
  },
}
